var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-notification',{attrs:{"link":_vm.toSettings,"title":_vm.$t('title'),"details":_vm.$t('body'),"actions":"","warning":""}})}
var staticRenderFns = []

export { render, staticRenderFns }